<template>
    <a-config-provider :locale="antdLAN">
        <a-layout class="n-mvh-1"
                  v-if="browserSuport">
            <a-layout-sider v-model:collapsed="collapsed"
                            collapsible
                            collapsedWidth="50"
                            width="250"
                            :trigger="null">
                <div class="n-col-1 n-plr-1 n-flex n-flex-a-c n-border-box n-logo">
                    <img :src="require('@/assets/image/logo-s-w.png')"
                         class="n-logo-small n-m-auto"
                         v-if="collapsed" />

                    <img :src="require('@/assets/image/logo-w.png')"
                         class="n-logo-big"
                         v-if="!collapsed" />

                    <h1 class="n-f-normal n-f-6 n-c-1 n-ml-2 n-m-0 n-keep-word"
                        v-if="!collapsed">{{LAN.APPName}}</h1>
                </div>

                <Menu></Menu>
            </a-layout-sider>
            <a-layout class="n-layout-right n-flex n-flex-dr-c">
                <a-layout-header class="n-header n-bg-1 n-plr-3 n-flex-s">
                    <Header :collapsed="collapsed"
                            @open="collapsed = false"
                            @close="collapsed = true"></Header>
                </a-layout-header>
                <a-layout-content class="n-p-2 n-flex-g n-flex-g-h-1-hack">
                    <div class="n-scroll-v n-h-1">
                        <router-view></router-view>
                    </div>
                </a-layout-content>
                <a-layout-footer class="n-bg-1 n-flex-s n-p-2 n-text-center">Copyright©2022 微创医疗 数字化能力中心</a-layout-footer>
            </a-layout>
        </a-layout>

        <h1 v-else
            class="n-browser">{{LAN.nui.browser}}</h1>
    </a-config-provider>
</template>
<script >
    import zhCN from 'ant-design-vue/es/locale/zh_CN';
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';

    import Menu from '@/components/Menu.vue'
    import Header from '@/components/Header.vue'

    import dayjs from 'dayjs';
    import 'dayjs/locale/zh-cn';
    import CONFIG from '@/assets/script/config'

    dayjs.locale('zh-cn');

    export default {
        name: 'App',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),

            /**
             * @description 检测浏览器兼容性
             */
            browserSuport () {
                var userAgent = navigator.userAgent,
                    ie6 = (/msie\s*(\d+)\.\d+/g.exec(userAgent.toLowerCase()) || [0, "0"])[1] == "6",
                    ie7 = userAgent.indexOf('MSIE 7.0') > -1,
                    ie8 = userAgent.indexOf('MSIE 8.0') > -1,
                    ie9 = userAgent.indexOf('MSIE 9.0') > -1;

                return !((ie6 || ie7 || ie8 || ie9) && location.href.indexOf('browser') <= 0)
            }
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                collapsed: false,
                antdLAN: zhCN
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize', 'setLevel', 'setStatus'])),

            NMounted () {
                window.addEventListener('resize', this.setWindowSize)

                this.request(CONFIG.RULE_HOST + this.API.constant, {
                    method: 'post',
                    data: { dictKey: 'task_priority' }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE_2) {
                        this.setLevel(res.data.map(item => {
                            return {
                                value: item.dictValue,
                                label: item.dictDesc
                            }
                        }))
                    }
                })

                this.request(CONFIG.RULE_HOST + this.API.constant, {
                    method: 'post',
                    data: { dictKey: 'task_status' }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE_2) {
                        var status = res.data.map(item => {
                            return {
                                value: parseInt(item.dictValue),
                                label: item.dictDesc
                            }
                        });

                        status = status.concat({
                            value: 0,
                            label: '已逾期'
                        })

                        this.setStatus(status)
                    }
                })
            }
        }),
        components: {
            Menu,
            Header
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    // 以下是框架代码
    .n-header {
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
        height: 50px;
        line-height: inherit;
    }

    .n-layout-right {
        min-width: 320px;
    }

    .n-logo {
        height: 50px;

        .n-logo-big {
            height: auto;
            width: 160px;
        }

        .n-logo-small {
            height: 30px;
            width: 30px;
        }

        h1 {
            margin-top: 3px;
        }
    }
</style>